import axios from 'axios'
import localStorage from 'local-storage'

const store = {
  namespaced: true,

  state: {
    active: false,
    query: null,
    results: [],
    recent: [],
  },
  getters: {
    active: state => state.active,
    results: state => state.results,
    recent: state => state.recent,
    query: state => state.query,
  },
  mutations: {
    SET_RESULTS (state, results) {
      state.results = results
    },
    SET_STATUS (state, status) {
      state.active = status
    },
    SET_QUERY (state, query) {
      state.query = query
    },
    APPEND_RECENT_QUERY (state, result) {
      state.recent.push(result)

      let recentQuery = JSON.parse(localStorage.get('search')) || []

      if (recentQuery.length > 5) {
        recentQuery.splice(4, 1)
      }

      recentQuery.push(result)

      localStorage.set('search', JSON.stringify(recentQuery))
    },
    INIT (state) {
      state.recent = JSON.parse(localStorage.get('search')) || []
    },
  },
  actions: {
    async setQuery ({ commit }, query) {
      commit('SET_QUERY', query)

      const response = await axios.get('/search', {
        params: { query },
      })

      commit('SET_RESULTS', response.data)
    },
    init ({ commit }) {
      commit('INIT')
    },
    recordRecent ({ commit }, result) {
      commit('APPEND_RECENT_QUERY', result)
    },
    open ({ commit }) {
      commit('SET_STATUS', true)
    },
    close ({ commit }) {
      commit('SET_QUERY', null)
      commit('SET_STATUS', false)
    },
  },
}

export default store
